import { render, staticRenderFns } from "./CheckoutWizardStepSummary.vue?vue&type=template&id=3f0578c6&scoped=true"
import script from "./CheckoutWizardStepSummary.vue?vue&type=script&lang=ts"
export * from "./CheckoutWizardStepSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0578c6",
  null
  
)

export default component.exports